<template>
  <IconLucideChevronsUp />
</template>
